/**
 * @generated SignedSource<<4b874c245df0918a46c3cd0e3eafc6f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveArchivableInput = {
  clientMutationId?: string | null;
  archivableId: string;
};
export type useArchiveHandler_Mutation$variables = {
  input: ArchiveArchivableInput;
  connections: ReadonlyArray<string>;
};
export type useArchiveHandler_MutationVariables = useArchiveHandler_Mutation$variables;
export type useArchiveHandler_Mutation$data = {
  readonly archiveArchivable: {
    readonly archivable: {
      readonly id: string;
      readonly isArchive: boolean;
    };
  } | null;
};
export type useArchiveHandler_MutationResponse = useArchiveHandler_Mutation$data;
export type useArchiveHandler_Mutation = {
  variables: useArchiveHandler_MutationVariables;
  response: useArchiveHandler_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useArchiveHandler_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ArchiveArchivablePayload",
        "kind": "LinkedField",
        "name": "archiveArchivable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "archivable",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useArchiveHandler_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ArchiveArchivablePayload",
        "kind": "LinkedField",
        "name": "archiveArchivable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "archivable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a81bbdf7026285f8d9121a32339a4d8c",
    "id": null,
    "metadata": {},
    "name": "useArchiveHandler_Mutation",
    "operationKind": "mutation",
    "text": "mutation useArchiveHandler_Mutation(\n  $input: ArchiveArchivableInput!\n) {\n  archiveArchivable(input: $input) {\n    archivable {\n      __typename\n      id\n      isArchive\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2acedf7966fd782a0c28922b4ca438a9";

export default node;
